export default {
    manage_createEditAssetSubtype_editTitle: "Editar Subtipo de Activo",
    manage_createEditAssetSubtype_createTitle: "Crear Nuevo Subtipo de Activo",
    manage_createEditAssetSubtype_createSuccess: "Subtipo de Activo Guardado",
    manage_createEditAssetSubtype_name: "Nombre",
    manage_createEditAssetSubtype_duplicatedName: "El nombre ya está en uso",
    manage_createEditAssetSubtype_are_in_use: "No es posible eliminar subtipos de activos en uso",
    manage_createEditAssetSubtype_successMessageCreate: "El subtipo de activo se ha creado correctamente",
    manage_createEditAssetSubtype_successMessageUpdate: "El subtipo de activo se ha actualizado correctamente",
    manage_createEditAssetSubtype_searchTable: "Buscar por Nombre",
}
